import { useMemo } from 'react';
import classNames from 'classnames';
import { BlogCategoriesItem, Section } from '@/components';
import type { Category } from '@/interfaces/strapi';
import { useStrapiGlobal } from '@/context';

type BlogCategoriesProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-blog-categories-list';

export const BlogCategories = ({ className }: BlogCategoriesProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	const { blogCategories } = useStrapiGlobal();

	return (
		<Section className={wrapperClassName} title="Actualidad Jurídica">
			<div className={`${classNameComponent}__grid`}>
				{blogCategories.length > 0 &&
					blogCategories.map((category) => <BlogCategoriesItem key={category.id} category={category} />)}
			</div>
		</Section>
	);
};
